import { atom } from 'jotai';
import { Socket } from 'socket.io-client';
import { ISocketConnectionState } from './socketStore.type';

export const socketAtom = atom<Socket | null>(null);

const initialSocketConnectionStateAtom: ISocketConnectionState = {
	isConnected: false,
	connectionError: null,
	connectionTimeout: null,
	reconnectionAttempt: null,
	reconnectionFailed: false
};

export const socketConnectionStateAtom = atom<ISocketConnectionState>(initialSocketConnectionStateAtom);
